import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getBlockOutDatesList(data) {
      try {
            const response = await callPostApi({ url: "blockout-dates/list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function deleteBlockOutDates(id) {
      try {
            const response = await callDeleteApi({ url: "blockout-dates/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function getDetailsBlockoutDates(id) {
      try {
            const response = await callGetApi({ url: "blockout-dates/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function addBlockOutDate(data) {
      try {
            const response = await callPostApi({ url: "blockout-dates/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function updateBlockOutDates(data) {
      try {
            const response = await callPutApi({ url: "blockout-dates/", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
export async function getZipCodesList(data) {
      try {
            const response = await callPostApi({ url: "store-settings/zipcode/storewise-list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

